This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div
    class="draggable drag-4"
    :class="checker ? 'selected' : ''"
    @click="clicked"
  >
    <div class="binop">
      <!-- Block as shown in the instructions container -->
      <div class="preview">
        {{ getType(type) }}
      </div>

      <!-- Block as shown in the PSD/IDE -->
      <div class="hidden codeBlock parent" ref="binop">
        <div class="blockEntry upperBorder value lhs"></div>
        <p>{{ getType(type) }}</p>
        <div class="blockEntry upperBorder value rhs"></div>

        <div class="var-input">
          <input type="text" class="hidden" autocomplete="off" />
          <select class="hidden"></select>
        </div>

        <div class="tooltip">
          <button class="button neutral hidden" style="display: none; pointer-events: none;">
            <img
              src="@/assets/images/icons/Switch.svg"
              alt="Switch between options and text icon"
            />
          </button>
          <div class="tooltipText top-6">
            <p>{{ $t("game.tooltips.psdSwitch") }}</p>
            <i></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import json from "@/psdLang/lang.json";
import { BinOpType } from "@/utils/Types";
import { addExtra, checkUsedBlock } from "@/utils/Functions";

@Options({
  name: "bin-op-block",
  beforeMount() {
    this.lang = this.$store.getters.getIDELanguage;
  },
  mounted() {
    let thisOp = this.$refs.binop;
    // Add binary operators on mount
    thisOp.classList.add(this.type);
    if (
      this.type == BinOpType.and ||
      this.type == BinOpType.or ||
      this.type == BinOpType.xor
    ) {
      thisOp.classList.add("boolOnly");
    } else if (
      this.type == BinOpType.gt ||
      this.type == BinOpType.lt ||
      this.type == BinOpType.lte ||
      this.type == BinOpType.gte
    ) {
      thisOp.classList.add("numOnly");
    }
  },
  props: {
    type: BinOpType,
  },
  data() {
    return {
      lang: null,
      json: json,
    };
  },
  methods: {
    //Get the type of the operator to display
    getType(type: BinOpType) {
      switch (type) {
        case BinOpType.eq:
          return "=";
        case BinOpType.neq:
          return "\u2260";
        case BinOpType.gt:
          return "\u003E";
        case BinOpType.lt:
          return "\u003C";
        case BinOpType.gte:
          return "\u2265";
        case BinOpType.lte:
          return "\u2264";
        case BinOpType.and:
          return this.getTranslation("and");
        case BinOpType.or:
          return this.getTranslation("or");
        case BinOpType.xor:
          return this.getTranslation("xor");
        default:
          return "";
      }
    },
    /**
     * Get translation of item
     * @param s String to be translated
     */
    getTranslation(s: string) {
      return this.json[this.lang][s];
    },
    clicked() {
      addExtra(this.type);
    },
  },
  computed: {
    checker() {
      return checkUsedBlock(this.type);
    },
  },
})
export default class BinOp extends Vue {}
</script>
